<template>
    <box-dropdown no-closing-el-selector="#product-details-popup">
        <template slot="selected-item">
            <div class="selected-item">
                <span class="default-label mr-1" v-if="selected_wine_id === defaultWine.id">{{ $t('wineSelect.default') }}</span>
                <span class="name">{{ selectedItem.name }}</span>
                <span class="price">{{ priceToString(selectedItem.price) }}</span>
                <i
                    v-if="selected_wine_id !== defaultWine.id"
                    class="fas fa-times clear-btn"
                    @click.stop="clearSelection"
                ></i>
            </div>
        </template>
        <template slot="dropdown" slot-scope="{closeDropdown}">
            <perfect-scrollbar-container>
                <div class="dropdown">
                    <div class="item-list">
                        <div class="item" v-for="wine in wines">
                            <img class="photo" :src="wine.photo_filepath" alt="">
                            <div class="info">
                                <span class="default-label mr-1" v-if="wine.id === wines[0].id">{{ $t('wineSelect.default') }}</span>
                                {{ wine.name }}<br>
                                {{ priceToString(wine.price) }}<br>
                                <a class="intro-trigger" href="" @click.prevent="introTriggerOnClick(wine.id)">{{ $t('wineSelect.intro') }}</a>
                                <span class="btn-select" v-on:click="() => $emit('update-selected-wine-id', productWineGroupId, wine.id) && closeDropdown()">
                            {{ $t('common.select') }}
                        </span>
                            </div>
                        </div>
                    </div>
                </div>
            </perfect-scrollbar-container>
        </template>
    </box-dropdown>
</template>

<script>
    import PerfectScrollbarContainer from './PerfectScrollbarContainer';
    import BoxDropdown from './BoxDropdown';

    export default {
        props: [
            'productWineGroupId',
            'wines',
            'selected_wine_id'
        ],
        components: {
            BoxDropdown,
            PerfectScrollbarContainer
        },
        computed: {
            defaultWine() {
                return this.wines[0];
            },
            selectedItem() {
                return this.getWine(this.$props.selected_wine_id);
            }
        },
        methods: {
            getWine(wineId) {
                return this.$props.wines.find(item => item.id === wineId)
            },
            priceToString(price) {
                let _price = Number.parseFloat(price);
                _price = isNaN(_price) ? 0 : _price;
                return `+$${ _price.toFixed(2)}`
            },
            introTriggerOnClick(wineId) {
                const popup = window.popups.productDetailsPopup;
                const wine = this.getWine(wineId);
                popup.openPopup();
                popup.popup.find('.content').html(wine.details);
            },
            clearSelection() {
                this.$emit('update-selected-wine-id', this.productWineGroupId, this.defaultWine.id)
            }
        },
    }
</script>

<style lang="stylus" type="text/stylus" scoped>
    .selected-item
        width: 100%
        display: flex
        padding: 5px 10px
        font-size: 0.8em
        min-width: 0
        .name
            text-overflow: ellipsis
            white-space: nowrap
            overflow: hidden
        .price
            white-space: nowrap
        .clear-btn
            border-radius: 50%
            border: 1px solid #000
            width: 20px
            height: 20px
            display inline-flex
            align-items: center
            justify-content: center
            margin: 0 5px
            min-width: 20px
            align-self: center
            &:hover
                opacity: 0.7
    .dropdown
        width: 100%
        max-height: 400px;
    .item-list
        padding: 0 30px 0 10px
    .item
        display: flex
        border-bottom: #7b7b7b 1px solid
        &:last-child
            border-bottom: none
        .photo
            width: 60px
            height: 120px
        .info
            position: relative
            padding-bottom: 40px
            font-size: 0.8em
            line-hieght: 160%
            flex: 2 1;
            .intro-trigger
                color: #313131
                &:hover
                    opacity 0.7
            .btn-select
                position: absolute
                font-size: 1em
                bottom: 10px
                right: 0
                padding: 0 40px
                background-color: #000
                color: #fff
                cursor: pointer
                &:hover
                    opacity: 0.7
    .default-label
        white-space: nowrap
        border-radius: 3px
        background-color: #000
        color: #fff
        font-weight: bold
        font-size: 10px
        height: 22px
        padding: 0 5px
        display: inline-flex
        align-items: center
        align-self: center
</style>